"use strict";

import index from "./pages/index.js";
import error404 from "./pages/error404.js";
import campaign from "./pages/campaign.js";
import login from "./pages/login.js";
import postlogin from "./pages/postlogin.js";
import logout from "./pages/logout.js";
import utils from "./services/utils.js";
import header from "./pages/header.js";

// List of supported routes. Any url other than these routes will throw a 404 error
const routes = {
  "/": { page: index, secured: true },
  "/campaign/:id": { page: campaign, secured: true },
  "/login": { page: login, secured: false },
  "/login/callback": { page: postlogin, secured: false },
  "/logout": { page: logout, secured: false },
};

// The router code. Takes a URL, checks against the list of supported routes and then renders the corresponding content page.
const router = async () => {
  // Lazy load view element:
  const headerContent = null || document.getElementById("header_container");
  const content = null || document.getElementById("content");
  // const footer = null || document.getElementById("footer_container");

  // // Render the Header and footer of the page
  headerContent.innerHTML = await header.render();
  await header.after_render();
  // footer.innerHTML = await Bottombar.render();
  // await Bottombar.after_render();

  // Get the parsed URl from the addressbar
  let request = utils.parseRequestUrl();
  if (!request.resource) request = utils.parseRequestUrlNonHashed();

  // Parse the URL and if it has an id part, change it with the string ":id"
  let parsedUrl =
    (request.resource ? "/" + request.resource : "/") +
    (request.id ? "/:id" : "") +
    (request.verb ? "/" + request.verb : "");

  // Get the page from our hash of supported routes.
  // If the parsed URL is not in our list of supported routes, select the 404 page instead
  let { page, secured } = routes[parsedUrl] ? routes[parsedUrl] : error404;
  if (secured) {
    if (!localStorage.getItem("access_token")) {
      // localStorage.removeItem("access_token");
      // localStorage.removeItem("sas_tokens");
      redirectToLogin();
    }
    let { exp } = utils.parseJwt(localStorage.getItem("access_token"));
    if (new Date(exp * 1000) <= new Date()) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("sas_tokens");
      redirectToLogin();
    }
  }

  content.innerHTML = await page.render();
  await page.after_render();
};

const redirectToLogin = () => {
  window.location = "/login";
};

// Listen on hash change:
window.addEventListener("hashchange", router);

// Listen on page load:
window.addEventListener("load", router);
